// src/extenders/mega-menu.js
var MegaMenu = class extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.megaMenuItems = this.querySelectorAll(".mega-menu-item");
    this.normalItems = this.querySelectorAll(".menu-item:not(.mega-menu-item)");
    this.megaMenuShadow = this.querySelector(".mega-menu-shadow");
    this.predictiveSearch = document.querySelector("predictive-search");
  }
  connectedCallback() {
    var _a;
    for (const item of this.megaMenuItems) {
      item.addEventListener("mouseenter", this.handleHover.bind(this, item));
    }
    for (const item of this.normalItems) {
      item.addEventListener("mouseenter", this.hideAllMegaMenu.bind(this));
    }
    (_a = this.megaMenuShadow) == null ? void 0 : _a.addEventListener("mouseenter", this.hideAllMegaMenu.bind(this));
  }
  handleHover(hoveredItem) {
    this.isOpen = true;
    if (this.predictiveSearch) {
      this.predictiveSearch._closeSearch();
    }
    for (const item of this.megaMenuItems) {
      if (hoveredItem.id === item.id) {
        item.classList.add("menu-active");
        item.nextElementSibling.setAttribute("aria-hidden", "false");
      } else {
        item.classList.remove("menu-active");
        item.nextElementSibling.setAttribute("aria-hidden", "true");
      }
    }
  }
  hideAllMegaMenu() {
    if (!this.isOpen) {
      return;
    }
    for (const item of this.megaMenuItems) {
      item.classList.remove("menu-active");
      item.nextElementSibling.setAttribute("aria-hidden", "true");
    }
    this.isOpen = false;
  }
};
if (!window.customElements.get("mega-menu")) {
  window.customElements.define("mega-menu", MegaMenu);
}
